<h1 matDialogTitle>Merge Customers</h1>
<div fxLayout="column" fxLayoutAlign="start start" matDialogContent>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
        <div fxFlex="0 0 50" fxLayout="column">
            <h2>Source Customer</h2>
            <p><i>This customer will have all its dockets, bookings and comments transferred to the "Destination
                Customer", and will be deleted</i></p>
            <p><strong>{{sourceCustomer | customerName}}</strong></p>
            <p>{{sourceCustomer | customerAddress}}</p>
            <p>{{sourceCustomer | customerContactDetails}}</p>
        </div>
        <div fxFlex="0 0 50" fxLayout="column">
            <h2>Destination Customer</h2>
            <p><i>This is the customer that you want to keep, and transfer the "Source Customer's" contracts/invoices,
                bookings and comments to.</i></p>
            <ng-container *ngIf="!destinationCustomer; else showDestinationCust">
                <p>Please select a customer using the search field below.</p>
                <mat-form-field>
                    <input matInput [formControl]="customerSearch" name="Customer select" [matAutocomplete]="auto"
                           name="Search"
                           placeholder="Search Customers" type="search">
                </mat-form-field>
                <mat-autocomplete [displayWith]="clearContentAfterSelect"
                                  (optionSelected)="destinationCustomer = $event.option.value"
                                  #auto="matAutocomplete">
                    <mat-option *ngFor="let option of filteredCustomers$ | async"
                                [value]="option">
                        <span>{{option | customerName}}</span>
                        <span><small>{{option | customerAddress}}</small></span>
                    </mat-option>
                </mat-autocomplete>
            </ng-container>
            <ng-template #showDestinationCust>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <p fxFlex="0 1 100"><strong>{{destinationCustomer | customerName}}</strong></p>
                    <button fxFlex="0 0 auto" mat-icon-button (click)="destinationCustomer = null"
                            matTooltip="Select Different Customer">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                <p>{{destinationCustomer | customerAddress}}</p>
                <p>{{destinationCustomer | customerContactDetails}}</p>
            </ng-template>
        </div>
    </div>
</div>
<div fxLayout="row" fxLayoutAlign="end center" matDialogActions>
    <button matDialogClose mat-raised-button>Cancel</button>
    <button [disabled]="!destinationCustomer || merging" mat-raised-button color="primary" (click)="doMerge()">Merge
    </button>
</div>
